import React from "react";
import ColorCollapsible from "./ColorCollapsible";

class ColorSetList extends React.Component {
  state = {
    selectedColorId: this.props.selectedColor.category_id,
  };

  handleExpandColors = (categoryId) => {
    this.setState({
      selectedColorId: categoryId,
    });
  };

  render() {
    const colorValues = Object.values(this.props.colorCategories),
      colorGroup = colorValues.map((category) => {
        return (
          <ColorCollapsible
            key={category.id}
            categoryId={category.id}
            layerId={this.props.layerId}
            type={this.props.type}
            title={category.name}
            colors={category.colors}
            selectedColor={this.props.selectedColor}
            selectedColorId={this.state.selectedColorId}
            handleExpandColors={this.handleExpandColors}
          />
        );
      });

    return <div>{colorGroup}</div>;
  }
}

export default ColorSetList;
